export const OFFICIAL_CONTACTS = {
  organization: 'Glooci Platform',
  address: 'Benevento, Italia',
  phone: '+39 0824 000000',
  website: 'https://www.glooci.it',
  websiteLabel: 'www.glooci.it',
};

export const PROJECT_CREATOR = {
  name: 'The Thinking Clouds',
  website: 'https://www.thethinkingclouds.com',
  websiteLabel: 'www.thethinkingclouds.com',
};
